export const Ptag = () => {
  return (
    <div>Ptag</div>
  )
}
